import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__title" }

import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';
import { INVENTORY_DASHBOARD_PATH } from '../constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'InventoryDashboardChildLayout',
  setup(__props) {

const t = i18n.t;

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, {
        to: _unref(INVENTORY_DASHBOARD_PATH),
        class: "ignore-hover"
      }, {
        default: _withCtx(() => [
          _createVNode(Mdi, {
            icon: "arrow_back",
            variant: "round"
          })
        ], undefined, true),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('ダッシュボード')), 1)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})